import { App } from 'vue'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'

export const initAntd = function(app: App) {
  app.use(Antd)
  return app
}
